import axios from '../../admin-axios';
import { detectError } from '../../utils';
import ActionType from '../action-types';

// eslint-disable-next-line import/prefer-default-export
export const getUnApprovedTransactions = (stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_UNAPPROVED_TRANSACTIONS_START,
      payload: { page }
    });

    try {
      // send request to get unapproved transactions
      const response = await axios.get(`/transaction/unapproved/${stationId}?page=${page}`);
      // const response = await axios.get(`/transaction/unapproved/${stationId}`);
      const { data } = response.data.data;
      const sortedData = data.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at); // ascending
      });

      dispatch({
        type: ActionType.FETCH_UNAPPROVED_TRANSACTIONS_SUCCESS,
        payload: {
          transactions: sortedData,
          total: response.data.data.total,
          current_page: response.data.data.current_page,
          per_page: response.data.data.per_page
        } // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.FETCH_UNAPPROVED_TRANSACTIONS_ERROR,
        payload: message
      });
    }
  };
};

export const searchUnApprovedTransactions = (query) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.UNAPPROVED_TRANSACTIONS_SEARCH_START
    });

    try {
      // send request to get approved transactions
      const response = await axios.get(`/transaction/search/unapproved/${query}`);
      dispatch({
        type: ActionType.UNAPPROVED_TRANSACTIONS_SEARCH_SUCCESS,
        payload: [response.data.data] // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.UNAPPROVED_TRANSACTIONS_SEARCH_ERROR,
        payload: message
      });
    }
  };
};

export const filterUnapprovedTransactions = (date, stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FILTER_UNAPPROVED_TRANSACTIONS_START
    });

    try {
      // send request to get approved transactions
      const response = await axios.post(`/transaction/unapproved/date/${stationId}?page=${page}`, {
        date
      });
      dispatch({
        type: ActionType.FILTER_UNAPPROVED_TRANSACTIONS_SUCCESS,
        payload: response.data.data // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.FILTER_UNAPPROVED_TRANSACTIONS_ERROR,
        payload: message
      });
    }
  };
};

export const setUnApprovedView = (view) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.SET_UNAPPROVED_TRANSACTIONS_VIEW,
      payload: view
    });
  };
};
